"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanAlarmObj = void 0;
var constants_1 = require("../constants");
var helpers_1 = require("./utils/helpers");
var formatters_1 = require("./utils/formatters");
var validator_1 = require("./utils/validator");
var cleanAlarmObj = function (alarm) {
    var _a, _b, _c, _d;
    delete alarm.valar;
    delete alarm.begin;
    delete alarm.end;
    // not supported
    if ((_a = alarm.trigger) === null || _a === void 0 ? void 0 : _a.RELATED) {
        return null;
    }
    if ((_b = alarm.trigger) === null || _b === void 0 ? void 0 : _b.VALUE) {
        var parsedValue = alarm.trigger.VALUE;
        if (parsedValue.indexOf('DURATION:') !== -1) {
            parsedValue = parsedValue.slice('DURATION:'.length);
        }
        alarm.trigger = parsedValue;
    }
    // not supported
    if (((_c = alarm.trigger) === null || _c === void 0 ? void 0 : _c.indexOf('DATE-TIME')) !== -1) {
        return null;
    }
    if (((_d = alarm.trigger) === null || _d === void 0 ? void 0 : _d.indexOf('DT')) !== -1) {
        return null;
    }
    return alarm;
};
exports.cleanAlarmObj = cleanAlarmObj;
/**
 * Split string events to array
 * @param iCalEvents
 * @param key
 */
var splitStringEvents = function (iCalEvents, key) {
    if (key === void 0) { key = constants_1.EVENT_BEGIN_KEY_VALUE; }
    // Get array of events
    var result = iCalEvents.split(key).slice(1);
    if (!result) {
        return '';
    }
    // Add missing delimiter from split to each record
    result = result.map(function (item) { return "".concat(key).concat(item); });
    return result;
};
var getResult = function (rawString, warnings, fallbackTimezone) {
    var eventObj = {};
    // extract VALARMS from string
    var _a = (0, helpers_1.extractProperty)(rawString, 'VALARM'), mainProperty = _a.mainProperty, extractedProperty = _a.extractedProperty;
    var alarmsString = extractedProperty;
    // Format event string, merge multiline values
    (0, formatters_1.formatStringToKeyValueObj)(mainProperty, eventObj, warnings, fallbackTimezone);
    // format alarms
    if (alarmsString && alarmsString.length > 0) {
        eventObj.alarms = [];
        var alarmStrings = (0, formatters_1.splitDataSetsByKey)(alarmsString, 'VALARM');
        alarmStrings.forEach(function (item) {
            var alarmObj = {};
            (0, formatters_1.formatStringToKeyValueObj)(item, alarmObj, warnings);
            var cleanedAlarm = (0, exports.cleanAlarmObj)(alarmObj);
            if (cleanedAlarm) {
                eventObj.alarms.push(cleanedAlarm);
            }
        });
    }
    return eventObj;
};
var getOneEventJSON = function (rawString, warnings, fallbackTimezone) {
    return getResult(rawString, warnings, fallbackTimezone);
};
var getOneTodoJSON = function (rawString, warnings) {
    return getResult(rawString, warnings);
};
/**
 * Main function
 * Get key values from each line to build obj
 * @param iCalStringEvent
 * @param fallbackTimezone
 */
var toJSON = function (iCalStringEvent, fallbackTimezone) {
    var errors = [];
    var warnings = [];
    var events = [];
    var todos = [];
    try {
        // Validate string
        (0, validator_1.validateICalString)(iCalStringEvent);
    }
    catch (e) {
        errors.push(e.message);
        return {
            calendar: {
                begin: '',
                prodid: '',
                version: '',
                end: '',
            },
            events: events,
            todos: todos,
            warnings: warnings,
            errors: errors,
        };
    }
    // Get vcalendar props
    var vCalendarString = (0, helpers_1.getVCalendarString)(iCalStringEvent);
    var calendar = (0, formatters_1.formatVCalendarStringToObject)(vCalendarString, warnings);
    // Get base content
    var baseCalendarContent = iCalStringEvent.slice(vCalendarString.length, iCalStringEvent.length - constants_1.CALENDAR_END_KEY_VALUE.length);
    baseCalendarContent = baseCalendarContent.replaceAll('MAILTO:', 'mailto:');
    // Extract vtodos
    var _a = (0, helpers_1.extractProperty)(baseCalendarContent, 'VTODO'), mainProperty = _a.mainProperty, extractedProperty = _a.extractedProperty;
    var eventsString = mainProperty;
    var todosString = extractedProperty;
    // Remove not supported properties
    var stringCleaned = (0, helpers_1.removeProperty)(eventsString, 'DAYLIGHT');
    stringCleaned = (0, helpers_1.removeProperty)(stringCleaned, 'VTIMEZONE');
    stringCleaned = (0, helpers_1.removeProperty)(stringCleaned, 'STANDARD');
    // Split string events to array
    var vEventsArray = splitStringEvents(stringCleaned);
    // Split string todos to array
    var vTodosArray = splitStringEvents(todosString, constants_1.TODO_BEGIN_KEY_VALUE);
    // Parse each event to obj
    vEventsArray.forEach(function (stringEvent) {
        try {
            var event_1 = getOneEventJSON(stringEvent, warnings, fallbackTimezone);
            events.push(event_1);
        }
        catch (e) {
            errors.push(e.message);
        }
    });
    vTodosArray.forEach(function (stringTodo) {
        try {
            var todo = getOneTodoJSON(stringTodo, warnings);
            todos.push(todo);
        }
        catch (e) {
            errors.push(e.message);
        }
    });
    return {
        calendar: calendar,
        events: events,
        todos: todos,
        errors: errors,
        warnings: warnings,
    };
};
exports.default = toJSON;
